'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slugify = function slugify() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-');
};

exports.slugify = slugify;